export enum environment {
    development = 'development',
    production = 'production',
    test = 'test',
    local = 'local',
}

export function isProdEnv() {
    return process.env.REACT_APP_ENVIRONMENT === environment.production;
}

export function isDevEnv() {
    return process.env.REACT_APP_ENVIRONMENT === environment.development;
}


export function isProdOrDevEnv() {
    return isProdEnv() || isDevEnv();
}